import { gql } from '@apollo/client'

export const CREATE_UPDATE_PAYMENT_METHOD_PORTAL_SESSION = gql`
  mutation CreateUpdatePaymentMethodPortalSession {
    createUpdatePaymentMethodPortalSession {
      url
    }
  }
`
